"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingStatusEnum = exports.SharedOrderItemStatusEnum = exports.OrderItemStateEnum = exports.OrderStateEnum = void 0;
var OrderStateEnum;
(function (OrderStateEnum) {
    OrderStateEnum["Active"] = "Active";
    OrderStateEnum["Refunded"] = "Refunded";
    OrderStateEnum["PartiallyRefunded"] = "Partial Refund";
    OrderStateEnum["Canceled"] = "Canceled";
})(OrderStateEnum = exports.OrderStateEnum || (exports.OrderStateEnum = {}));
;
var OrderItemStateEnum;
(function (OrderItemStateEnum) {
    OrderItemStateEnum["Active"] = "Active";
    OrderItemStateEnum["Canceled"] = "Canceled";
    OrderItemStateEnum["Offered"] = "Offered";
    OrderItemStateEnum["Shared"] = "Shared";
})(OrderItemStateEnum = exports.OrderItemStateEnum || (exports.OrderItemStateEnum = {}));
;
var SharedOrderItemStatusEnum;
(function (SharedOrderItemStatusEnum) {
    SharedOrderItemStatusEnum["Sent"] = "Sent";
    SharedOrderItemStatusEnum["Accepted"] = "Accepted";
    SharedOrderItemStatusEnum["Rejected"] = "Rejected";
    SharedOrderItemStatusEnum["Cancelled"] = "Cancelled";
})(SharedOrderItemStatusEnum = exports.SharedOrderItemStatusEnum || (exports.SharedOrderItemStatusEnum = {}));
;
var SharingStatusEnum;
(function (SharingStatusEnum) {
    SharingStatusEnum["isAddOnsSharing"] = "isAddOnsSharing";
    SharingStatusEnum["isTicketSharing"] = "isTicketSharing";
})(SharingStatusEnum = exports.SharingStatusEnum || (exports.SharingStatusEnum = {}));
;
//# sourceMappingURL=IOrderState.js.map